export default {
    intro: 'Put the jumbled sentences in the correct order!',
    indicator: ({ values }: { values: { isAllDone: boolean } }) => {
        const { isAllDone } = values;
        if (isAllDone) {
            return 'Read the completed text once more.';
        }
        return 'Put the sentences in the correct order!';
    },
    table: {
        question: 'Question',
        answerRate: 'Accuracy',
        emptyMessage: 'No content available.',
    },
    roundNumber: 'No. {number}',
};
